/**
 * The PazNet mark (the PAZ / NET box from `public/logo.svg`) drawn inline in
 * `currentColor`, so it takes the surrounding text colour and reads on light
 * and dark surfaces alike. `logo.svg` is white-only and is kept for the dark
 * login screens. `size` is the height in px; widths follow the viewBox ratios
 * so nothing reflows. The wordmark hides on narrow screens.
 */
export function PazNetMark({ size = 44, wordmark = true, className }: { size?: number; wordmark?: boolean; className?: string }) {
  return (
    <span role="img" aria-label="PazNetworks, Inc." className={`inline-flex flex-none items-center text-text ${className ?? ''}`} style={{ gap: size * 0.22 }}>
      <svg viewBox="0 0 80 80" width={size} height={size} className="flex-none" aria-hidden>
        <rect x="2" y="2" width="76" height="76" rx="12" stroke="currentColor" strokeWidth="3" fill="none" />
        <text x="40" y="38" textAnchor="middle" fill="currentColor" fontFamily="inherit" fontSize="22" fontWeight="800" letterSpacing="2">PAZ</text>
        <line x1="14" y1="48" x2="66" y2="48" stroke="currentColor" strokeWidth="2" opacity="0.5" />
        <text x="40" y="66" textAnchor="middle" fill="currentColor" fontFamily="inherit" fontSize="18" fontWeight="700" letterSpacing="3">NET</text>
      </svg>
      {wordmark && (
        <svg viewBox="0 0 250 80" width={(size * 250) / 80} height={size} className="hidden flex-none md:block" aria-hidden>
          <text x="0" y="42" fill="currentColor" fontFamily="inherit" fontSize="28" fontWeight="700" letterSpacing="0.5">PazNetworks, Inc.</text>
          <text x="0" y="64" fill="currentColor" fontFamily="inherit" fontSize="14" fontWeight="400" opacity="0.65">Technology Solutions</text>
        </svg>
      )}
    </span>
  );
}
